export type UpdateCallback = (dt: number, elapsed: number) => void;
export type RenderCallback = () => void;

export class GameLoop {
  private running = false;
  private animFrameId = 0;
  private lastTime = 0;
  private elapsed = 0;
  private onUpdate: UpdateCallback;
  private onRender: RenderCallback;

  constructor(onUpdate: UpdateCallback, onRender: RenderCallback) {
    this.onUpdate = onUpdate;
    this.onRender = onRender;
  }

  start(): void {
    if (this.running) return;
    this.running = true;
    this.lastTime = performance.now();
    this.tick();
  }

  stop(): void {
    this.running = false;
    if (this.animFrameId) {
      cancelAnimationFrame(this.animFrameId);
      this.animFrameId = 0;
    }
  }

  resetTime(): void {
    this.elapsed = 0;
    this.lastTime = performance.now();
  }

  getElapsed(): number {
    return this.elapsed;
  }

  private tick = (): void => {
    if (!this.running) return;
    this.animFrameId = window.requestAnimationFrame(this.tick);

    const now = performance.now();
    const dt = Math.min((now - this.lastTime) / 1000, 0.1);
    this.lastTime = now;
    this.elapsed += dt;

    try {
      this.onUpdate(dt, this.elapsed);
      this.onRender();
    } catch (e) {
      console.error('[GameLoop] Error in update/render:', e);
    }
  };
}
